import { Typename } from 'src/constants/typenames'
import { types } from 'mobx-state-tree'

export const genereateNodeTypename = (type: Typename) => types.optional(types.literal(type), type)
